import $$auth from 'models/auth';
import { $notifiable } from 'models/participants';

import { opposite } from 'utils/common-helper';

$notifiable.reset($$auth.$isAuthenticated.updates.filter({ fn: opposite }));
